module.exports = __webpack_public_path__ + "static/media/decoracao_06.bbfa66ee.jpg";